export function getInitialOption(
  fieldKey: string | null | undefined,
  initial: any,
  lang: "ru" | "ky"
): { value: number; label: string } | null {
  if (!fieldKey) return null;

  const nested = initial?.[fieldKey];
  if (nested?.id != null) {
    const label =
      lang === "ru"
        ? nested?.nameRu ?? String(nested?.id)
        : nested?.nameKy ?? String(nested?.id);
    return { value: Number(nested.id), label };
  }

  const flatId = initial?.[`${fieldKey}Id`];
  if (flatId != null) return { value: Number(flatId), label: `#${flatId}` };

  return null;
}
